var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      staticClass: "yxtbiz-select-dimension",
      attrs: {
        title: _vm.$t("pc_biz_title_select_dimension").d("选择维度"),
        size: "960px",
        visible: _vm.isShow,
        "before-close": _vm.beforeClosDialog,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      !_vm.isEmpty
        ? _c(
            "div",
            { staticClass: "yxtbiz-select-dimensional__content" },
            [
              _c(
                "dimensional-list",
                { staticClass: "mb16", attrs: { name: _vm.name } },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    _vm._l(_vm.jqTypes.slice(0, -1), function (item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "flex align-items-center mr16",
                        },
                        [
                          _c("point-label", {
                            attrs: {
                              name: item.name,
                              type: item.id,
                              "is-left": true,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._l(_vm.jqDimBeans, function (jq) {
                return [
                  jq.show
                    ? _c(
                        "dimensional-list",
                        {
                          key: jq.id,
                          staticClass: "sub-bean",
                          attrs: { name: jq.itemCustomName },
                        },
                        [
                          _vm._l(jq.subJqDimBeans, function (sub) {
                            return [
                              sub.show
                                ? _c(
                                    "div",
                                    { key: sub.id, staticClass: "sub-bean" },
                                    [
                                      _c("point-label", {
                                        attrs: {
                                          name: sub.itemCustomName,
                                          type: sub.itemType,
                                        },
                                      }),
                                      _c("dimensional-box", {
                                        staticClass: "mt8",
                                        attrs: {
                                          isForm: _vm.isForm,
                                          list: sub.jqRequireDetailBeans,
                                          rtModelDetail: _vm.rtModelDetail,
                                          skillModelDetail:
                                            _vm.skillModelDetail,
                                          defaultCheckedKeys:
                                            _vm.defaultCheckedKeys,
                                          checkedKeys: _vm.checkedKeys,
                                        },
                                        on: {
                                          "update:skillModelDetail": function (
                                            $event
                                          ) {
                                            _vm.skillModelDetail = $event
                                          },
                                          "update:skill-model-detail":
                                            function ($event) {
                                              _vm.skillModelDetail = $event
                                            },
                                          "update:checkedKeys": function (
                                            $event
                                          ) {
                                            _vm.checkedKeys = $event
                                          },
                                          "update:checked-keys": function (
                                            $event
                                          ) {
                                            _vm.checkedKeys = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _c("div", { staticClass: "yxtbiz-select-dimensional__empty" }, [
            _c("img", {
              staticClass: "yxtbiz-select-dimensional__empty__img",
              attrs: {
                src:
                  this.$staticBaseUrl +
                  "ufd/c4d5f9/talentrv/pc/img/sp-exmpt.png",
              },
            }),
            _c(
              "span",
              { staticClass: "yxtbiz-select-dimensional__empty__text mt16" },
              [
                _vm._v(
                  _vm._s(
                    _vm
                      .$t("pc_biz_msg_no_dimension_rule")
                      .d("暂无设置规则的维度，请前往任职资格进行管理查看")
                  )
                ),
              ]
            ),
          ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            {
              attrs: { plain: "" },
              on: {
                click: function ($event) {
                  _vm.isShow = false
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_biz_core_btn_cancel").d("取消")) +
                  "\n    "
              ),
            ]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.onComplete } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_biz_common_btn_sure").d("确定")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }